module.exports = __webpack_public_path__ + "static/media/laxmirajW3.9a2a6514.png";